export const SEGMENT_LABELS: Record<string, string> = {
  condominium: 'Condomínio',
  club: 'Clube',
  cowork: 'Coworking',
}

export const ROLE_LABELS: Record<string, string> = {
  owner: 'Proprietário',
  admin: 'Administrador',
  manager: 'Gerente',
  member: 'Membro',
  viewer: 'Visualizador',
}

export const STATUS_LABELS: Record<string, string> = {
  requested: 'Solicitada',
  approved: 'Aprovada',
  rejected: 'Rejeitada',
  cancelled: 'Cancelada',
  noshow: 'Não compareceu',
  checked_in: 'Em uso',
  completed: 'Concluída',
}

export const RESOURCE_TYPE_LABELS: Record<string, string> = {
  room: 'Sala de Reunião',
  court: 'Quadra',
  kiosk: 'Quiosque',
  hall: 'Salão de Festas',
  desk: 'Hot Desk',
}



export const WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

export const WEEKDAY_LABELS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

